import React from 'react';
import { connect } from 'react-redux';
import i18n from 'util/i18n';
import { updateApplication } from '@redux/modules/application/actions';
import { REVIEW_AND_SUBMIT, REVIEW_AND_SUBMIT_COMMENTS } from 'config/formSections/review';
import SectionNavigation from 'components/Section/shared/SectionNavigation';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import { PackageCommentsModel } from 'forms/sections/package/comments/types';
import { Dispatch } from 'redux';
import { RootState } from 'types/state';
import { updateSubsectionRequest } from '@redux/modules/form/actions';

const sectionConfig = {
  key: REVIEW_AND_SUBMIT_COMMENTS.key,
  section: REVIEW_AND_SUBMIT.name,
  store: REVIEW_AND_SUBMIT.store,
  subsection: REVIEW_AND_SUBMIT_COMMENTS.name,
  storeKey: REVIEW_AND_SUBMIT_COMMENTS.storeKey,
};

interface Props extends Partial<PackageCommentsModel> {
  required?: boolean
  /**
   * Dispatch is required, as it is used for the functions.
   */
  dispatch: Dispatch
  location?: any
}

const PackageComments: React.FC<Props> = ({
  HasComments,
  Comments,
  required,
  dispatch,
  location,
}) => {
  const updateBranch = (values: PackageCommentsModel['HasComments']) => {
    const updatedValues = { HasComments: values };

    // TODO: Refactor to match other subsections
    dispatch(updateApplication(sectionConfig.store, sectionConfig.storeKey, updatedValues));

    dispatch(updateSubsectionRequest(sectionConfig.key, updatedValues));
  };

  const updateComments = (values: PackageCommentsModel['Comments']) => {
    const updatedValues = { Comments: values };

    // TODO: Refactor to match other subsections
    dispatch(
      updateApplication(sectionConfig.store, sectionConfig.storeKey, {
        HasComments,
        ...updatedValues,
      })
    );

    dispatch(
      updateSubsectionRequest(sectionConfig.key, {
        HasComments,
        ...updatedValues,
      })
    );
  };

  return (
    <div className="view">
      <div className="section-content">
        <h1 className="section-header">{i18n.t('review.commentsHeader')}</h1>
        <Branch
          name="has_comments"
          label={i18n.t('review.commentsBranchLabel')}
          labelSize="h4"
          {...HasComments}
          warning
          required={required}
          onUpdate={updateBranch}
          attribute="HasComments"
        />
        <Show when={HasComments && HasComments.value === 'Yes'}>
          <Field title={i18n.t('review.commentsTitle')} adjustFor="textarea" attribute="Comments">
            {/* eslint jsx-a11y/label-has-associated-control: 0 */}
            <label htmlFor="Comments">{i18n.t('review.commentsLabel')}</label>
            <Textarea
              name="Comments"
              attribute="Comments"
              {...Comments}
              required={required}
              onUpdate={updateComments}
            />
          </Field>
        </Show>
      </div>

      <SectionNavigation currentPath={location.pathname} />
    </div>
  );
};

PackageComments.defaultProps = {
  HasComments: {},
  Comments: {},
  required: false,
  dispatch: () => { },
  location: {},
  formType: '',
};

// TODO: Move to state.form
const mapStateToProps = (state: RootState) => {
  const { application } = state;
  const { Package = {} } = application;
  const { Comments = {} } = Package;

  return {
    HasComments: Comments.HasComments,
    Comments: Comments.Comments,
    formType: application.Settings.formType,
  };
};

export default connect(mapStateToProps)(PackageComments);
